import axios from 'axios';

const getList = params => axios.get('/grupo-produtos-gestao', {
  params,
});

export default {
  getList,
};
